import { render, staticRenderFns } from "./OnboardingName.vue?vue&type=template&id=737936d2&scoped=true&"
import script from "./OnboardingName.vue?vue&type=script&lang=js&"
export * from "./OnboardingName.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingName.vue?vue&type=style&index=0&id=737936d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737936d2",
  null
  
)

export default component.exports